import { render, staticRenderFns } from "./lp-wine-investment-made-easy.vue?vue&type=template&id=6e33ebd2&scoped=true"
import script from "./lp-wine-investment-made-easy.vue?vue&type=script&lang=js"
export * from "./lp-wine-investment-made-easy.vue?vue&type=script&lang=js"
import style0 from "./lp-wine-investment-made-easy.vue?vue&type=style&index=0&id=6e33ebd2&prod&scoped=true&lang=css"
import style1 from "./lp-wine-investment-made-easy.vue?vue&type=style&index=1&id=6e33ebd2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e33ebd2",
  null
  
)

export default component.exports